import { authPost } from './http';

// --- wire types (mirror services/api internal/auth) ---

/** The enrolled second factor. `sms` has to be sent a code before one can be typed. */
export type MfaMethod = 'totp' | 'sms';

/** A single-use authorisation for one high-value action (SEC-07). Spent by the
 *  first money call that presents it; lives `expires_in` seconds otherwise. */
export interface StepUpGrant {
  step_up_token: string;
  expires_in: number;
}

/** Trade a live code (app, SMS or recovery) for a step-up token. A wrong code is
 *  401 invalid_mfa_code; the route shares the 10-a-minute sign-in limit. */
export const requestStepUp = (token: string, code: string) =>
  authPost<StepUpGrant>('/me/step-up', token, { code });

/** Text a fresh code to an SMS-enrolled account. 422 not_sms_enrolled for an app. */
export const sendMfaCode = (token: string) => authPost<{ sent: boolean }>('/me/mfa/send-code', token);
